import {
  CONNECT_BANK_FAILED,
  CONNECT_BANK_SUCCESS,
} from 'consts/analytics/bankConnectionEvents';
import { URLS } from 'consts/api/urls';
import { RequestMethods } from 'consts/enums/requests';
import { AXIOS_FETCHERS } from 'hooks/api/SWR/axios/axiosFetchers';
import { analytics } from 'hooks/integrations/mixpanel/useMixpanel';
import { PlaidLinkOnExit, PlaidLinkOnSuccess } from 'react-plaid-link';
import { toast } from 'react-toastify';
import { extractError } from 'utils/error_utils';

export const onBankConnectSuccess: PlaidLinkOnSuccess = async (
  publicToken,
  metadata
) => {
  const account = metadata.accounts[0];
  const institution = metadata.institution;
  if (!account)
    return analytics.track(CONNECT_BANK_FAILED, { reason: 'no account' });
  try {
    await AXIOS_FETCHERS.AUTHED_AXIOS_FETCHER({
      method: RequestMethods.POST,
      url: `${URLS.API_ENDPOINT}/plaid_account_details`,
      data: {
        data: {
          type: 'plaid_account_details',
          attributes: {
            account_id: account.id,
            account_name: account.name,
            subtype: account.subtype,
            institution_id: institution?.institution_id,
            institution_name: institution?.name,
            verification_status: account.verification_status,
            plaid_link_token: publicToken,
          },
        },
      },
    });
    analytics.track(CONNECT_BANK_SUCCESS, { publicToken, metadata });
  } catch (error) {
    toast.error(extractError(error), { position: 'top-right' });
    analytics.track(CONNECT_BANK_FAILED, { error });
  }
};

export const onBankConnectExit: PlaidLinkOnExit = async (error, metadata) => {
  if (error) {
    toast.error(extractError(error), { position: 'top-right' });
    return analytics.track(CONNECT_BANK_FAILED, { ...error, ...metadata });
  }
};

export const disconnectBank = async (
  financialConnectionId?: string,
  successCallBack?: () => Promise<void>,
  errorCallBack?: () => void
) => {
  if (!financialConnectionId) {
    return;
  }
  try {
    await AXIOS_FETCHERS.AUTHED_AXIOS_FETCHER({
      url: `${URLS.API_ENDPOINT}/financial_connections/${financialConnectionId}`,
      method: RequestMethods.DELETE,
    });
    successCallBack && (await successCallBack());
  } catch (error) {
    errorCallBack && errorCallBack();
  }
};
